
// 経費レポート 円グラフ表示 (未実装)
// ✔ - 見積り内訳と経費の内訳の円グラフを、1つづつ表示
// ✔ - それぞれのグラフに詳細表示設定された経費を、項目ごとに表示
// ✔ - それぞれのグラフにその他の経費を、まとめて表示
// ✔ - グラフ内の凡例に、経費項目名を表示
// - グラフ内の項目ごとのツールチップの値に、単位を表示
// - グラフ内の項目ごとに、表示色を変更

// TODO: データの自動色分け

import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import { Pie } from "vue-chartjs";

@Component({
  extends: Pie
})
export default class ExpensesReportGraphEstimates extends Mixins(Pie) {
  @Prop({ required: true }) labels!: string[];
  @Prop({ required: true }) estimates!: number[];
  @Prop({ required: true }) expenses!: number[];
  @Prop({ required: true }) colors!: string[];

  mounted() {
    // 印刷時に黒塗りになってしまうのを防ぐ
    this.addPlugin({
      id: "custom-background-color",
      beforeDraw: (chart: any) => {
        const { ctx } = chart;
        ctx.save();
        ctx.globalCompositeOperation = "destination-over";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, chart.width, chart.height);
        ctx.restore();
      }
    });

    this.init();
  }

  @Watch("graphData")
  private init() {
    this.renderChart(this.graphData, {
      // 表示オプションを指定
      // cutoutPercentage: 50,
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false
        // position: "top"
      },
      title: {
        display: true,
        text: "見積額"
      },
      tooltips: {
        callbacks: {
          label(item, data) {
            const formatter = Intl.NumberFormat("ja-JP", {
              style: "currency",
              currency: "JPY"
            });
            return (
              data.labels![item.index!] +
              ": " +
              formatter.format(Number(data.datasets![0].data![item.index!]))
            );
          }
        }
      }
    });
    // DEV: ここに二個目の renderChart を入れればグラフが2個出ると思ったが出なかった
    // this.renderChart(this.graphData2, {});
  }

  // グラフの色分けを props の colors からループ指定 (ScriptableContext)
  private setColor(graphItem?: any) {
    var index = graphItem.dataIndex;
    return this.colors[index % this.colors.length];
  }

  // 表示データを指定
  private get graphData() {
    return {
      labels: this.labels,
      datasets: [
        {
          backgroundColor: this.setColor,
          data: this.estimates
        }
      ]
    };
  }
}
